// extracted by mini-css-extract-plugin
module.exports = {"root":"VideoListing_root__0uMkE","header":"VideoListing_header__QCXyS","container":"VideoListing_container__BIuLN","item":"VideoListing_item__hWRGr"};